import { Link } from 'react-router-dom'
import { RegisterForm } from '../../components/auth'

export function RegisterPage() {
  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center py-12 px-4">
      <div className="w-full max-w-md">
        {/* Logo */}
        <Link to="/" className="flex items-center justify-center mb-8">
          <img
            src="/logo-vertical.png"
            alt="Exercise Toolbox"
            className="h-24 object-contain"
          />
        </Link>

        {/* Card */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8">
          <RegisterForm />
        </div>
      </div>
    </div>
  )
}
